import {Widget, defineCustomWidget} from '@acng/frontend-stargazer';
import {replaceUrl} from '@acng/frontend-relativity/history';
import {addClass, body, removeClass} from '@acng/frontend-bounty';
import {CTX_OBSERVE, CTX_PROVIDE} from '@acng/frontend-relativity/minify';

import {ctxAmateur} from 'acng/amateurPool/context/amateur.js';
import {VERBOSE} from 'acng/core/service/debug.js';
import {inject, isInjectable, ngDigest} from 'acng/core/service/ng.js';
import {promise} from 'acng/pin/service/cache.js';

import {messengerFeature} from '../config/feature.js';
import {ctxGlobalDialog, setGlobalDialog} from '../context/global-dialog.js';
import {dialogs, getDialog, online} from '../service/dialogs.js';
import {query} from '@acng/frontend-bounty/dom/query.js';
import {isMobile} from 'acng/core/service/env.js';
import {list} from '../../friend/service/cache.js';
import {STATE_CONFIRMED} from '../../friend/model/friendship.js';
import {popup} from '@acng/frontend-discovery';
import {get} from '../../amateurPool/service/cache.js';

const MODULE = 'messenger/widget/messenger';

const DISCONNECT = Symbol();
import {authUser} from 'acng/userPool/context/auth-user.js';
import {parseInteger} from '@acng/frontend-bounty/std/number.js';
import {globalValue, Watch} from '@acng/frontend-relativity';
import {ctxMatches} from 'acng/hotornot/context/list.js';
import {setup} from 'acng/hotornot/service/match.js';

const watch = Watch(`onsw-messenger`, ctxMatches);

class MessengerElement extends Widget {
  static consumables = [ctxGlobalDialog];

  /*
  clickFriends() {
    if (friendError) {
      popup(this).warn(friendError.message);
    }
  }
  */

  connectedCallback() {
    const scope = inject('$rootScope');
    let sequence = 0;
    scope.friends = list(STATE_CONFIRMED);
    promise.then((pins) => (scope.pins = pins));
    scope.dialogs = dialogs;
    scope.dialogs.online = () => online;
    scope.matches = [];
    watch(this, (element, matches) => {
      scope.matches = [...matches];
      //@ts-ignore
      scope.matches.changed = sequence++;
    });
    setup();
    // }

    ctxAmateur[CTX_PROVIDE](this, null);

    super.connectedCallback();

    ctxGlobalDialog[CTX_OBSERVE](this, async (amateurId, previousId) => {
      DEBUG: VERBOSE(this) && console.info(`${MODULE} reflect global dialog`, {amateurId, previousId});

      if (previousId) {
        if (previousId == amateurId) {
          return;
        }
        getDialog(previousId).open = false;
      }

      if (!amateurId) {
        ctxAmateur[CTX_PROVIDE](this, null);
        scope.dialogAmateur = null;
        removeClass(body, 'show-dialog');
        return;
      }

      const amateur = await get(amateurId);

      getDialog(amateurId).open = true;

      ctxAmateur[CTX_PROVIDE](this, amateur);
      if (!isMobile) {
        // TODO Improve that
        setTimeout(() => query(this, 'textarea')?.focus());
      }
      scope.dialogAmateur = amateur;
      addClass(body, 'show-dialog');
    });

    this[DISCONNECT] = [scope.$on('$locationChangeSuccess', openDialogFromLocation)];

    openDialogFromLocation();
  }

  disconnectedCallback() {
    this[DISCONNECT]?.forEach((cb) => cb());
    delete this[DISCONNECT];
  }

  closeDialog() {
    setGlobalDialog(null);
    ngDigest();
  }
}

defineCustomWidget(messengerFeature, 'onsw-messenger', MessengerElement);

/**
 * Conditionally open the dialog given by route param and remove the route param
 * WITHOUT pushing the history.
 *
 * @returns {void}
 */
const openDialogFromLocation = () => {
  const params = new URLSearchParams(location.hash.replace(/^#?\/?\??/, ''));

  if (!params.has('openMessenger')) {
    return;
  }

  const id = parseInteger(params.get('openMessenger')) || dialogs[0]?.id;
  if (id) {
    if (authUser) {
      setGlobalDialog(id.toString(), true);
    } else {
      // guest
      const onsOverlay = inject('onsOverlay');
      onsOverlay.create('pageLogin', {reason: 'messenger.guestOpenDialog'}).disableBackdrop().open();
      const remove = inject('$rootScope').$on('userPool.login.success', () => {
        setGlobalDialog(id.toString(), true);
        remove();
      });
    }

    params.delete('openMessenger');
    replaceUrl(`#/${params.size ? `?${params}` : ''}`);
  }
};
